import { app } from '@microsoft/teams-js';

export type ExpectedFailureReason = app.ExpectedFailureReason;
export type FailedReason = app.FailedReason;
export const ExpectedFailureReason: typeof app.ExpectedFailureReason = app.ExpectedFailureReason;
export const FailedReason: typeof app.FailedReason = app.FailedReason;

export class MetaOsHubNotFoundError extends Error {
  public readonly name: string = 'MetaOsHubNotFoundError';

  constructor(message?: string) {
    super(message);
  }
}
